export default __webpack_public_path__ + "2ee84906731e2f9b1d8ef447724831d8.png";